module.exports = __webpack_public_path__ + "img/qr.4dad01e7.svg";